import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { Authcontext } from "../../context/Authcontext";
const Navbar = () => {
  const nevigate = useNavigate();
  const { user } = useContext(Authcontext);
  const handlelocat = (e) => {
    nevigate("/login");
  };
  return (
    <div className="navbar">
      <div className="navcontainer">
        <Link to="/">
          <span className="logo">
            <span style={{ color: "black" }}>V</span>-Bookings
          </span>{" "}
        </Link>
        {user ? (
          user.username
        ) : (
          <div className="navitems">
            <button className="navbutton">Register</button>

            <button className="navbutton" onClick={handlelocat}>
              Log-in
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
